import { render } from "./new-brand-on-off-setup.vue?vue&type=template&id=55acb092"
import script from "./new-brand-on-off-setup.vue?vue&type=script&lang=js"
export * from "./new-brand-on-off-setup.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/PRD_sharetreats_v1_hr_admin_dashboard_client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__